import helpUploader from './help/helpUploader';
require('jquery-validation');
window.onload = function () {
    helpUploader.init();
};
